import React, { useState } from 'react';
import { useEffect } from 'react';

import Label from './Label';
import Select from './Select';

const FilterInput = ({ options, onChange, label, value }) => {
  const [filterOption, setFilterOption] = useState(value || Object.keys(options)[0]);

  useEffect(() => {
    onChange(filterOption);
  }, [filterOption]);

  return (
    <div>
      {label && <Label>{label}</Label>}
      <Select onChange={e => setFilterOption(e.target.value)} className="w-32 max-w-64">
        {Object.keys(options).map(key => (
          <option key={key} selected={key === filterOption} value={key}>
            {options[key].label}
          </option>
        ))}
      </Select>
    </div>
  );
};

export default FilterInput;
